import React, { useState } from 'react';
import DashboardLayout from '@/layouts/DashboardLayout';
import { ServicesList } from '@/components/services/ServicesList';
import { ServiceEditor } from '@/components/services/ServiceEditor';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const Services: React.FC = () => {
  const [editingServiceId, setEditingServiceId] = useState<string | null>(null);
  const [isCreating, setIsCreating] = useState(false);

  const handleEdit = (serviceId: string) => {
    setEditingServiceId(serviceId);
    setIsCreating(false);
  };

  const handleNew = () => {
    setEditingServiceId(null);
    setIsCreating(true);
  };

  const handleClose = () => {
    setEditingServiceId(null);
    setIsCreating(false);
  };

  return (
    <DashboardLayout>
      <div className="container max-w-6xl mx-auto px-4 py-8">
        <ServicesList onEdit={handleEdit} onNew={handleNew} />

        <Dialog open={isCreating || !!editingServiceId} onOpenChange={handleClose}>
          <DialogContent className="max-w-2xl">
            <DialogHeader>
              <DialogTitle>
                {editingServiceId ? 'Edit Service' : 'Create New Service'}
              </DialogTitle>
              <DialogDescription>
                {editingServiceId
                  ? 'Update your service details and booking requirements'
                  : 'Configure a new service for your clients to book'}
              </DialogDescription>
            </DialogHeader>
            <ServiceEditor serviceId={editingServiceId || undefined} />
          </DialogContent>
        </Dialog>
      </div>
    </DashboardLayout>
  );
};

export default Services; 